import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcAvatarIndicator]'
})
export class AvatarIndicatorDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
